import React from 'react';
import { AdProvider } from './src/components/BannerAd';
import { MantineProvider } from '@mantine/core';
import { theme } from './theme';

export function wrapPageElement({ element }) {
  return (
    <MantineProvider theme={theme}>
      <AdProvider>{element}</AdProvider>
    </MantineProvider>
  );
}
